export const CANVAS_CHANGE_VIEW = 'CANVAS_CHANGE_VIEW';
export const CANVAS_CHANGE_PREVIEW_DEVICE = 'CANVAS_CHANGE_PREVIEW_DEVICE';
export const CANVAS_ENABLE_HIGHLIGHT = 'CANVAS_ENABLE_HIGHLIGHT';
export const CANVAS_DISABLE_HIGHLIGHT = 'CANVAS_DISABLE_HIGHLIGHT';
export const CANVAS_RESET_STATE = 'CANVAS_RESET_STATE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/canvas/types.js
 **/